import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import ayanaLogo from '../imgs/ayana client_.png';
import tamayazLogo from '../imgs/tamayaz.png';
import eshElsaadaLogo from '../imgs/esh elsaada.png';
import dimaClinicLogo from '../imgs/dima clinic dental.png';
import conceptZoneLogo from '../imgs/concept zone client.png';
import bedonDawaLogo from '../imgs/bedon dawa client.png';
import faviconIco from '../favicon.ico';

const FalconsSections = () => {
    return (
        <>
            {/* About Start */}
            <div id="about" className="container-fluid px-0">
                <div className="container-fluid px-0">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-7 pb-0 pb-lg-5 py-5">
                            <div className="pb-0 pb-lg-5 py-5">
                                <div className="title wow fadeInUp text-center" data-wow-delay="0.1s">
                                    <div className="title-center">
                                        <h5>انضم إلينا</h5>
                                        <h1>من نحن</h1>
                                    </div>
                                </div>
                                <p className="mb-4 wow fadeInUp px-lg-5" data-wow-delay="0.2s" dir="rtl" style={{ textAlign: 'center', direction: 'rtl', paddingLeft: '30px', paddingRight: '30px' }}>
                                    <span dir="ltr">Falcons</span> هي وكالة تسويق واستشارات رقمية تقدم حلولًا متكاملة ومخصصة تناسب احتياجات السوق المصري والعربي. نعمل وفق منهجيات مهنية تعتمد على البيانات والتحليل لضمان وصول الرسالة الصحيحة إلى العميل المناسب بأعلى كفاءة.
                                </p>
                                <ul className="list-group list-group-flush mb-5 wow fadeInUp" data-wow-delay="0.3s">
                                    <li className="list-group-item bg-dark text-body border-secondary ps-0">
                                        <i className="fa fa-check-circle text-primary me-1"></i> نؤمن بأن النجاح يقاس بالنتائج لا بالكلمات.
                                    </li>
                                    <li className="list-group-item bg-dark text-body border-secondary ps-0">
                                        <i className="fa fa-check-circle text-primary me-1"></i> الإبداع أساس كل حملة ناجحة.
                                    </li>
                                    <li className="list-group-item bg-dark text-body border-secondary ps-0">
                                        <i className="fa fa-check-circle text-primary me-1"></i> العمل بشراكة طويلة الأمد مع عملائنا.
                                    </li>
                                </ul>
                                <div className="row wow fadeInUp" data-wow-delay="0.4s">
                                    <div className="col-6">
                                        <a href="#" className="btn btn-outline-primary border-2 py-3 w-100">استشارة مجانية</a>
                                    </div>
                                    <div className="col-6">
                                        <a href="#" className="btn btn-primary py-3 w-100">شاهد أعمالنا</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="1s">
                            <img className="img-fluid rounded shadow-lg" src="/img/falcons_about.png" alt="Falcons Marketing Agency" style={{ borderRadius: '20px' }} />
                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}

            {/* Banner Start */}
            <div className="container-fluid py-5 bg-secondary px-0">
                <div className="container-fluid py-5 px-0">
                    <div className="row g-0 justify-content-center">
                        <div className="col-lg-7 text-center">
                            <div className="title mx-5 px-5 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="title-center">
                                    <h5>هل لديك مشروع تجاري؟</h5>
                                    <h1>ابحث عن شريك تسويق حقيقي</h1>
                                </div>
                            </div>
                            <p className="fs-5 mb-5 wow fadeInUp" data-wow-delay="0.2s" dir="rtl">
                                في <span dir="ltr">Falcons</span>، لا نقدم حملات دعائية فقط، بل نبني منهجية متكاملة تساعدك على الظهور، التأثير، والتحويل إلى نتائج ملموسة في جميع المجالات.
                            </p>
                            <div className="position-relative wow fadeInUp" data-wow-delay="0.3s">
                                <input className="form-control border-0 bg-dark rounded-pill w-100 py-4 ps-4 pe-5" type="text" placeholder="  رقم التواصل" style={{ textAlign: 'right' }} />
                                <button type="button" className="btn btn-primary py-3 px-4 position-absolute top-0 start-0 ms-2" style={{ marginTop: '7px' }}>تواصل معنا الآن</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Banner End */}

            {/* Service Start */}
            <section id="services" className="services-section-wrapper container-fluid py-5 px-0" dir="rtl">
                <div className="container-fluid py-5 px-0">
                    <div className="text-center">
                        <div className="title wow fadeInUp" data-wow-delay="0.1s">
                            <div className="title-center">
                                <h5>خدماتنا</h5>
                                <h1>كيف نساعدك</h1>
                            </div>
                        </div>
                    </div>
                    <div className="service-item service-item-right">
                        <div className="row g-0 align-items-center">
                            <div className="col-md-5">
                                <div className="service-img p-5 wow fadeInRight" data-wow-delay="0.2s">
                                    <img className="img-fluid rounded-circle" src="/img/service_real_estate.jpg" alt="" style={{ width: '400px', height: '400px', objectFit: 'cover' }} />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="service-text px-5 px-md-0 py-md-5 wow fadeInRight" data-wow-delay="0.5s">
                                    <h3 className="text-uppercase">التسويق العقاري</h3>
                                    <p className="mb-4">نقدم حلول تسويقية متخصصة للمطورين العقاريين والمكاتب التسويقية تشمل بناء الهوية التجارية، إدارة الحملات الإعلانية، وإنتاج المحتوى التسويقي المتميز.</p>
                                    <a className="btn btn-outline-primary border-2 px-4" href="#">اقرأ المزيد <i className="fa fa-arrow-left ms-1"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="service-item service-item-left">
                        <div className="row g-0 align-items-center">
                            <div className="col-md-5">
                                <div className="service-img p-5 wow fadeInRight" data-wow-delay="0.2s">
                                    <img className="img-fluid rounded-circle" src="/img/service_medical.jpg" alt="" style={{ width: '400px', height: '400px', objectFit: 'cover' }} />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="service-text px-5 px-md-0 py-md-5 wow fadeInRight" data-wow-delay="0.5s">
                                    <h3 className="text-uppercase">التسويق الطبي</h3>
                                    <p className="mb-4">نقدم حلول تسويقية متخصصة للقطاع الطبي والصحي تشمل إدارة الحملات الإعلانية، بناء الهوية التجارية، وإنتاج محتوى طبي احترافي يخضع للمعايير الطبية.</p>
                                    <a className="btn btn-outline-primary border-2 px-4" href="#">اقرأ المزيد <i className="fa fa-arrow-left ms-1"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="service-item service-item-right">
                        <div className="row g-0 align-items-center">
                            <div className="col-md-5">
                                <div className="service-img p-5 wow fadeInRight" data-wow-delay="0.2s">
                                    <img className="img-fluid rounded-circle" src="/img/service_ecommerce.jpg" alt="" style={{ width: '400px', height: '400px', objectFit: 'cover' }} />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="service-text px-5 px-md-0 py-md-5 wow fadeInRight" data-wow-delay="0.5s">
                                    <h3 className="text-uppercase">نمو المتاجر الإلكترونية</h3>
                                    <p className="mb-4">نساعد المتاجر الإلكترونية على النمو من خلال استراتيجيات تسويقية متكاملة تشمل تحسين محركات البحث، إدارة الحملات الإعلانية، وتحسين تجربة المستخدم.</p>
                                    <a className="btn btn-outline-primary border-2 px-4" href="#">اقرأ المزيد <i className="fa fa-arrow-left ms-1"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="service-item service-item-left">
                        <div className="row g-0 align-items-center">
                            <div className="col-md-5">
                                <div className="service-img p-5 wow fadeInRight" data-wow-delay="0.2s">
                                    <img className="img-fluid rounded-circle" src="/img/service_ppc.jpg" alt="" style={{ width: '400px', height: '400px', objectFit: 'cover' }} />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="service-text px-5 px-md-0 py-md-5 wow fadeInRight" data-wow-delay="0.5s">
                                    <h3 className="text-uppercase">إدارة الحملات الإعلانية (PPC)</h3>
                                    <p className="mb-4">نخطط وننفذ حملات إعلانية مدفوعة فعالة على منصات التواصل الاجتماعي ومحركات البحث لضمان وصول رسالتك إلى العملاء المناسبين في الوقت المناسب مع تحقيق أفضل عائد استثمار.</p>
                                    <a className="btn btn-outline-primary border-2 px-4" href="#">اقرأ المزيد <i className="fa fa-arrow-left ms-1"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service End */}

            {/* Portfolio Start */}
            <div id="portfolio" className="container-fluid py-5 bg-secondary px-0 px-0">
                <div className="container-fluid py-5 px-0">
                    <div className="row g-0">
                        <div className="col-sm-12 col-md-8 col-lg-6">
                            <div className="h-100 p-5 bg-dark d-flex align-items-center justify-content-center">
                                <div className="title mb-0 wow fadeIn" data-wow-delay="0.1s">
                                    <div className="title-left">
                                        <h5>أعمالنا</h5>
                                        <h1>نماذج من مشاريعنا</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
                            <div className="portfolio-item overflow-hidden">
                                <img className="img-fluid" src={ayanaLogo} alt="Ayana" />
                                <div className="portfolio-overlay">
                                    <div className="portfolio-btn">
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href={ayanaLogo} data-lightbox="portfolio"><i className="fa fa-eye"></i></a>
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href="#"><i className="fa fa-link"></i></a>
                                    </div>
                                    <div className="portfolio-name">
                                        <h5 className="text-uppercase mb-0">Ayana</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 col-md-4 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
                            <div className="portfolio-item overflow-hidden">
                                <img className="img-fluid" src={tamayazLogo} alt="Tamayaz" />
                                <div className="portfolio-overlay">
                                    <div className="portfolio-btn">
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href={tamayazLogo} data-lightbox="portfolio"><i className="fa fa-eye"></i></a>
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href="#"><i className="fa fa-link"></i></a>
                                    </div>
                                    <div className="portfolio-name">
                                        <h5 className="text-uppercase mb-0">Tamayaz</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
                            <div className="portfolio-item overflow-hidden">
                                <img className="img-fluid" src={eshElsaadaLogo} alt="Esh Elsaada" />
                                <div className="portfolio-overlay">
                                    <div className="portfolio-btn">
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href={eshElsaadaLogo} data-lightbox="portfolio"><i className="fa fa-eye"></i></a>
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href="#"><i className="fa fa-link"></i></a>
                                    </div>
                                    <div className="portfolio-name">
                                        <h5 className="text-uppercase mb-0">Esh Elsaada</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
                            <div className="portfolio-item overflow-hidden">
                                <img className="img-fluid" src={dimaClinicLogo} alt="Dima Clinic" />
                                <div className="portfolio-overlay">
                                    <div className="portfolio-btn">
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href={dimaClinicLogo} data-lightbox="portfolio"><i className="fa fa-eye"></i></a>
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href="#"><i className="fa fa-link"></i></a>
                                    </div>
                                    <div className="portfolio-name">
                                        <h5 className="text-uppercase mb-0">Dima Clinic</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
                            <div className="portfolio-item overflow-hidden">
                                <img className="img-fluid" src={conceptZoneLogo} alt="Concept Zone" />
                                <div className="portfolio-overlay">
                                    <div className="portfolio-btn">
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href={conceptZoneLogo} data-lightbox="portfolio"><i className="fa fa-eye"></i></a>
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href="#"><i className="fa fa-link"></i></a>
                                    </div>
                                    <div className="portfolio-name">
                                        <h5 className="text-uppercase mb-0">Concept Zone</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
                            <div className="portfolio-item overflow-hidden">
                                <img className="img-fluid" src={bedonDawaLogo} alt="Bedon Dawa" />
                                <div className="portfolio-overlay">
                                    <div className="portfolio-btn">
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href={bedonDawaLogo} data-lightbox="portfolio"><i className="fa fa-eye"></i></a>
                                        <a className="btn btn-lg-square btn-outline-primary border-2 mx-1" href="#"><i className="fa fa-link"></i></a>
                                    </div>
                                    <div className="portfolio-name">
                                        <h5 className="text-uppercase mb-0">Bedon Dawa</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4 col-lg-3">
                            <div className="h-100 p-5 bg-dark d-flex flex-column align-items-center justify-content-center wow fadeIn" data-wow-delay="0.3s">
                                <a href="#" className="btn btn-outline-primary border-2 py-3 w-100 mb-3">عرض المزيد</a>
                                <a href="#" className="btn btn-primary py-3 w-100">تواصل معنا</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Portfolio End */}

            {/* Team Start */}
            <div className="container-fluid py-5 px-0">
                <div className="container-fluid py-5 px-0">
                    <div className="text-center">
                        <div className="title wow fadeInUp" data-wow-delay="0.1s">
                            <div className="title-center">
                                <h5>لماذا <span dir="ltr">Falcons</span>؟</h5>
                                <h1>نقاط تميزنا</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="team-item">
                                <div className="team-body">
                                    <div className="team-before">
                                        <span>فهم عميق</span>
                                        <span>لطبيعة السوق</span>
                                        <span>العقاري المصري</span>
                                    </div>
                                    <img className="img-fluid" src="/img/real_estate_market_orange.png" alt="" style={{ width: '100%', height: '350px', objectFit: 'cover' }} />
                                    <div className="team-after">
                                        <span>خبرة</span>
                                        <span>عميقة</span>
                                        <span>في السوق</span>
                                    </div>
                                </div>
                                <a className="team-name" href="#">
                                    <h5 className="text-uppercase mb-0">فهم السوق</h5>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="team-item">
                                <div className="team-body">
                                    <div className="team-before">
                                        <span>استراتيجيات</span>
                                        <span>تسويق عالية</span>
                                        <span>الاحترافية</span>
                                    </div>
                                    <img className="img-fluid" src="/img/marketing_strategy_orange.png" alt="" style={{ width: '100%', height: '350px', objectFit: 'cover' }} />
                                    <div className="team-after">
                                        <span>مبنية</span>
                                        <span>على</span>
                                        <span>دراسة</span>
                                    </div>
                                </div>
                                <a className="team-name" href="#">
                                    <h5 className="text-uppercase mb-0">استراتيجيات احترافية</h5>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="team-item">
                                <div className="team-body">
                                    <div className="team-before">
                                        <span>تقارير أداء</span>
                                        <span>واضحة توضح</span>
                                        <span>العائد من كل حملة</span>
                                    </div>
                                    <img className="img-fluid" src="/img/performance_reports_orange.png" alt="" style={{ width: '100%', height: '350px', objectFit: 'cover' }} />
                                    <div className="team-after">
                                        <span>شفافية</span>
                                        <span>كاملة</span>
                                        <span>في النتائج</span>
                                    </div>
                                </div>
                                <a className="team-name" href="#">
                                    <h5 className="text-uppercase mb-0">تقارير الأداء</h5>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="team-item">
                                <div className="team-body">
                                    <div className="team-before">
                                        <span>نرافق العميل</span>
                                        <span>من التخطيط</span>
                                        <span>وحتى تحقيق المبيعات</span>
                                    </div>
                                    <img className="img-fluid" src="/img/client_partnership_orange.png" alt="" style={{ width: '100%', height: '350px', objectFit: 'cover' }} />
                                    <div className="team-after">
                                        <span>شراكة</span>
                                        <span>مستمرة</span>
                                        <span>وشاملة</span>
                                    </div>
                                </div>
                                <a className="team-name" href="#">
                                    <h5 className="text-uppercase mb-0">شراكة شاملة</h5>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Team End */}

            {/* Testimonial Start */}
            <div className="container-fluid py-5 bg-secondary px-0">
                <div className="container-fluid py-5 px-0">
                    <div className="text-center">
                        <div className="title wow fadeInUp" data-wow-delay="0.1s">
                            <div className="title-center">
                                <h5>آراء العملاء</h5>
                                <h1>نظرة واقعية على نتائج العمل</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="text-center mb-5 wow fadeInUp" data-wow-delay="0.2s">
                                <p className="fs-5 mb-4" dir="rtl">في <span dir="ltr">Falcons</span>، نعتبر رأي العميل امتدادًا لنتائج العمل، وليس مجرد تعليق. لذلك نشارك هنا مجموعة مختصرة من انطباعات عملاء تعاملوا معنا في مشاريع فعلية داخل السوق المصري.</p>
                            </div>
                        </div>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.3s">
                        <Swiper
                            modules={[Autoplay, Pagination]}
                            spaceBetween={30}
                            slidesPerView={1}
                            loop={true}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            pagination={{ clickable: true }}
                            breakpoints={{
                                768: { slidesPerView: 2 },
                                1024: { slidesPerView: 3 }
                            }}
                            dir="rtl"
                            className="testimonial-swiper py-5"
                        >
                            <SwiperSlide>
                                <div className="testimonial-card h-100 p-5 bg-dark border border-secondary rounded-3 text-center position-relative overflow-hidden" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="mb-4">
                                        <div className="rounded-circle p-2 border border-primary mx-auto overflow-hidden" style={{ width: '100px', height: '100px' }}>
                                            <img className="img-fluid w-100 h-100" src="/img/client1.png" style={{ objectFit: 'cover' }} alt="أحمد سلامة" />
                                        </div>
                                    </div>
                                    <p className="fs-5 text-white mb-4">"التحسين في ظهور موقعي كان أسرع من المتوقع، وبدأنا نستقبل زيارات من كلمات كنا نظن الوصول لها يحتاج وقت أطول."</p>
                                    <hr className="w-25 mx-auto bg-primary mb-3" />
                                    <h5 className="text-uppercase text-white mb-1">أحمد سلامة</h5>
                                    <span className="text-primary fw-bold small">صاحب مشروع تقني ناشئ</span>
                                    <div className="position-absolute bottom-0 start-0 w-100 bg-primary" style={{ height: '4px', opacity: '0.3' }}></div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="testimonial-card h-100 p-5 bg-dark border border-secondary rounded-3 text-center position-relative overflow-hidden" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="mb-4">
                                        <div className="rounded-circle p-2 border border-primary mx-auto overflow-hidden" style={{ width: '100px', height: '100px' }}>
                                            <img className="img-fluid w-100 h-100" src="/img/client2.png" style={{ objectFit: 'cover' }} alt="سارة الجوهري" />
                                        </div>
                                    </div>
                                    <p className="fs-5 text-white mb-4">"أكثر نقطة شدّتني أنهم يشتغلون بطريقة تناسب السوق المصري فعلًا، لا يقدمون حلول جاهزة، بل يشخصون الحالة أول."</p>
                                    <hr className="w-25 mx-auto bg-primary mb-3" />
                                    <h5 className="text-uppercase text-white mb-1">سارة الجوهري</h5>
                                    <span className="text-primary fw-bold small">مسؤولة تسويق في قطاع التجارة</span>
                                    <div className="position-absolute bottom-0 start-0 w-100 bg-primary" style={{ height: '4px', opacity: '0.3' }}></div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="testimonial-card h-100 p-5 bg-dark border border-secondary rounded-3 text-center position-relative overflow-hidden" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="mb-4">
                                        <div className="rounded-circle p-2 border border-primary mx-auto overflow-hidden" style={{ width: '100px', height: '100px' }}>
                                            <img className="img-fluid w-100 h-100" src="/img/client3.png" style={{ objectFit: 'cover' }} alt="محمد إبراهيم" />
                                        </div>
                                    </div>
                                    <p className="fs-5 text-white mb-4">"الإعلان كان مصروف عليه قبل، لكن بعد ما استلموه صار العائد أوضح، نسبة التحويل ارتفعت والمبيعات تجاوزت 200% في وقت قياسي."</p>
                                    <hr className="w-25 mx-auto bg-primary mb-3" />
                                    <h5 className="text-uppercase text-white mb-1">محمد إبراهيم</h5>
                                    <span className="text-primary fw-bold small">مالك متجر إلكتروني للمنتجات اليومية</span>
                                    <div className="position-absolute bottom-0 start-0 w-100 bg-primary" style={{ height: '4px', opacity: '0.3' }}></div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="testimonial-card h-100 p-5 bg-dark border border-secondary rounded-3 text-center position-relative overflow-hidden" style={{ transition: 'all 0.3s ease' }}>
                                    <div className="mb-4">
                                        <div className="rounded-circle p-2 border border-primary mx-auto overflow-hidden" style={{ width: '100px', height: '100px' }}>
                                            <img className="img-fluid w-100 h-100" src="/img/client4.png" style={{ objectFit: 'cover' }} alt="ليلى حسن" />
                                        </div>
                                    </div>
                                    <p className="fs-5 text-white mb-4">"التعامل مع فالكونز مريح جداً، بيفهموا في التفاصيل وعندهم صبر في تنفيذ الطلبات لحد ما نوصل لأحسن نتيجة."</p>
                                    <hr className="w-25 mx-auto bg-primary mb-3" />
                                    <h5 className="text-uppercase text-white mb-1">ليلى حسن</h5>
                                    <span className="text-primary fw-bold small">مديرة مبيعات في قطاع التجزئة</span>
                                    <div className="position-absolute bottom-0 start-0 w-100 bg-primary" style={{ height: '4px', opacity: '0.3' }}></div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
            {/* Testimonial End */}

            {/* Footer Start */}
            <div id="contact" className="container-fluid bg-dark text-light footer py-5 wow fadeIn px-0" data-wow-delay="0.1s">
                <div className="container text-center py-5">
                    <a href="#">
                        <h1 className="display-4 mb-3 text-white text-uppercase" dir="rtl"><img src={faviconIco} alt="Falcons Logo" style={{ height: '50px', width: 'auto', marginLeft: '15px', marginBottom: '15px' }} /> <span dir="ltr">Falcons Marketing</span></h1>
                    </a>
                    <div className="d-flex justify-content-center mb-4">
                        <a className="btn btn-lg-square btn-outline-primary border-2 m-1" href="https://wa.me/201036202074"><i className="fab fa-whatsapp"></i></a>
                        <a className="btn btn-lg-square btn-outline-primary border-2 m-1" href="https://www.tiktok.com/@falcons.marketing"><i className="fab fa-tiktok"></i></a>
                        <a className="btn btn-lg-square btn-outline-primary border-2 m-1" href="https://www.instagram.com/falcons_marketing/"><i className="fab fa-instagram"></i></a>
                        <a className="btn btn-lg-square btn-outline-primary border-2 m-1" href="https://www.facebook.com/falconsmarketing/"><i className="fab fa-facebook-f"></i></a>
                        <a className="btn btn-lg-square btn-outline-primary border-2 m-1" href="https://www.linkedin.com/in/falcons-marketing-87a4413aa/"><i className="fab fa-linkedin-in"></i></a>
                        <a className="btn btn-lg-square btn-outline-primary border-2 m-1" href="https://www.behance.net/falconsmarketing"><i className="fab fa-behance"></i></a>
                    </div>
                    <p class="mb-3">البريد الإلكتروني: <a href="mailto:info@falcons-marketing.com" class="text-primary">info@falcons-marketing.com</a></p>
                    <p className="mb-3">المقر: <a href="https://maps.app.goo.gl/ZxsFJuum5VTEk8Vt5" target="_blank" rel="noopener noreferrer" className="text-primary">دمياط الجديدة</a></p>
                </div>
            </div>
            {/* Footer End */}

            {/* Copyright Start */}
            <div className="container-fluid bg-dark text-light border-top border-secondary py-4 px-0">
                <div className="container text-center">
                    <p dir="rtl" className="mb-0">&copy; <a className="text-primary fw-bold" href="mailto:info@falcons-marketing.com"><span dir="ltr">Falcons Marketing</span></a>, جميع الحقوق محفوظة.</p>
                </div>
            </div>
            {/* Copyright End */}

            {/* Back to Top */}
            <a href="#" className="btn btn-outline-primary border-2 btn-lg-square back-to-top"><i className="bi bi-arrow-up"></i></a>

            {/* Floating WhatsApp Button */}
            <a href="https://wa.me/201036202074" className="btn btn-success btn-lg-square floating-whatsapp" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i>
            </a>
        </>
    );
};

export default FalconsSections;
